import { ShoesState } from 'src/types'

const heelTopWithLaceAndStandingTongue = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.healDecoration.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(731, 269)
  ctx.quadraticCurveTo(752, 301, 771, 305)
  ctx.quadraticCurveTo(797, 311, 826, 311)
  ctx.quadraticCurveTo(834, 309, 840, 322)
  ctx.quadraticCurveTo(832, 290, 823, 235)
  ctx.quadraticCurveTo(820, 226, 816, 224)
  ctx.quadraticCurveTo(807, 230, 796, 260)
  ctx.quadraticCurveTo(769, 285, 731, 269)
  //   ctx.quadraticCurveTo(0, 0, 0, 0)
  //   ctx.quadraticCurveTo(0, 0, 0, 0)

  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.strokeStyle = 'white'
  ctx.lineWidth = 2.5
  ctx.beginPath()
  ctx.moveTo(729, 268) //つま先＿左下
  ctx.quadraticCurveTo(752, 302, 778, 307)
  ctx.quadraticCurveTo(795, 312, 823, 310)
  ctx.quadraticCurveTo(832, 307, 839, 323)
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(739, 273) // 左
  ctx.quadraticCurveTo(760, 302, 786, 303)
  ctx.quadraticCurveTo(823, 305, 823, 305)
  ctx.quadraticCurveTo(834, 302, 835, 311)
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'

  //   canvasResetter(ctx) // リセット
}

const defaultHeelTop = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.healDecoration.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(773, 260)
  ctx.quadraticCurveTo(820, 260, 840, 319)
  ctx.quadraticCurveTo(842, 319, 842, 319) // 右下
  ctx.quadraticCurveTo(845, 294, 840, 265)
  ctx.quadraticCurveTo(836, 234, 807, 233)
  ctx.quadraticCurveTo(798, 228, 792, 239)
  ctx.quadraticCurveTo(788, 251, 773, 260)
  //   ctx.quadraticCurveTo()

  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.strokeStyle = 'white'
  ctx.lineWidth = 2.5
  ctx.beginPath()
  ctx.moveTo(774, 258) //つま先＿左下
  ctx.quadraticCurveTo(824, 257, 842, 319)
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(784, 255) // 左
  ctx.quadraticCurveTo(822, 255, 842, 309)
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'

  //   canvasResetter(ctx) // リセット
}

export const heelTop = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  const openingPattern = state.openingPattern.value
  if (openingPattern === 'quarterCut') {
    heelTopWithLaceAndStandingTongue(ctx, state)
    return
  }
  defaultHeelTop(ctx, state)
}

// ctx.beginPath()
// ctx.moveTo(0, 0)
// ctx.quadraticCurveTo(0, 0, 0, 0)
// ctx.closePath()
